import { useSelector } from 'react-redux'
import useSWR from 'swr'

import { fetchSubscriptionOptions } from '@library/api-subscription'

import { getUserId } from 'selectors/user'

type SubscriptionOptionsResponse = {
  data?: {
    boxSize?: Array<{
      numPortions: number
    }>
  }
}

const swrKey = 'subscription-options'
const defaultAvailableBoxSizes = [2, 4]

export const useAvailableBoxSizes = (): {
  availableBoxSizes?: number[]
  isLoading: boolean
} => {
  const userId = useSelector(getUserId)

  const response = useSWR(
    {
      key: swrKey,
      userId,
    },
    fetchSubscriptionOptions,
    {
      shouldRetryOnError: false,
    },
  )

  const isLoading = !response.data && response.isValidating
  const fetchedAvailableBoxSizes =
    (response.data as SubscriptionOptionsResponse | undefined)?.data?.boxSize?.map(
      (box) => box.numPortions,
    ) || defaultAvailableBoxSizes

  return {
    availableBoxSizes: isLoading ? undefined : fetchedAvailableBoxSizes,
    isLoading,
  }
}
